// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rWuu","content":"styles_content__3TFmz","tableWrap":"styles_tableWrap__2TIWD"};